export const isEllipsisActive = (element) => {
    return element.offsetWidth < element.scrollWidth;
};
